import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { Buffer } from 'buffer';
import { createRoot } from 'react-dom/client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BreadcrumbsProvider } from '@intellecteu/common-ui';
import { Toast } from 'app/components/core';
import { useAuthSigninCallback } from 'app/utils/auth-signin-callback';
import { userManager } from 'data';
// TODO: decide if needed
import App from './pages';
import PrivateRoute from './utils/private-route';

import 'normalize.css';
import 'app/styles/global.scss';
import 'ui/styles/ui-kit.module.scss';

window.Buffer = Buffer;

const container = document.getElementById('root') as HTMLElement;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // default value
      retryDelay: 3 * 1000,
    },
  },
});

const AuthShell = () => {
  const onSigninCallback = useAuthSigninCallback();
  return (
    <BreadcrumbsProvider>
      <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
        <PrivateRoute>
          <App />
          <Toast />
        </PrivateRoute>
      </AuthProvider>
    </BreadcrumbsProvider>
  );
};

export const Canton = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthShell />
    </BrowserRouter>
    {import.meta.env.VITE_MODE === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

const root = createRoot(container);

root.render(<Canton />);
